import { useEffect, useState, version } from "react";
import { Modal, Button, Form, InputGroup, Card, Spinner } from "react-bootstrap";
import { getAllSectionVersions, getSectionVersionById } from "../../api/api";
import ConfirmModal from "../ConfirmModal";
import { useParams } from "react-router-dom";
import { useReportTemplateContext } from "./ReportTemplate/ReportTemplateContext";
import ToastMessage from "../ToastMessage";


function SectionVersionsGetter({ show, onClose }) {
    const [versiot, setVersiot] = useState([]);
    const [totalResults, setTotalResults] = useState(1)

    const [loading, setLoading] = useState(false);

    // ✅ Pagination state
    const [page, setPage] = useState(1);
    const [limit] = useState(6);
    const [totalPages, setTotalPages] = useState(1);


    // ✅ Confirmation modal state
    const [showConfirm, setShowConfirm] = useState(false);

    const [toast, setToast] = useState({ show: false, message: "", bg: "success" });

    const {              
      sectionId             
    } = useParams();
    
    const { handleBlockBlur, activeSection, bumpVersionKey } = useReportTemplateContext();


    const convertToFinnishTime = (utcDate) => {
        return new Date(utcDate).toLocaleString("fi-FI", {
            timeZone: "Europe/Helsinki",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });

    }
    
    useEffect(() => {
      if (!show) return; // ✅ only fetch when modal is visible

      // let isMounted = true; // for cleanup

      const fetchData = async () => {
        setLoading(true);
        try {
          const data = await fetchVersions(); // your fetch function
          // if (isMounted) setVersiot(data.items || []);
        } catch (err) {
          console.error(err);
        } finally {
          // if (isMounted) setLoading(false);
        }
      };

      fetchData();

      // return () => {
      //   isMounted = false; // cancel any state updates if modal closes mid-fetch
      // };
    }, [show]);
      


    const fetchVersions = async () => {
        setLoading(true)
        try{
            const fetchedVersiot = await getAllSectionVersions(sectionId)
            setTotalResults(fetchedVersiot.data.total)
            setVersiot(fetchedVersiot.data.items)
        }
        catch (error){
            alert('Error occured: ', error)
        }
        finally{
          setLoading(false)
        }
    }


      const fetchAndSetFullVersion = async (versionId) => {
        setLoading(true);
        try {
          const response = await getSectionVersionById(versionId);
          const fullVersion = response.data?.fullSection; // adjust if your API returns differently

          if (!fullVersion?.content) {
            alert("Valittu versio ei sisällä sisältöä");
            return;
          }

          const parsedContent =
            typeof fullVersion.content === "string"
              ? JSON.parse(fullVersion.content)
              : fullVersion.content;

          // Overwrite current editor content
          // setContent(parsedContent); 

            if (activeSection) {
              await handleBlockBlur(parsedContent, activeSection.id);
              bumpVersionKey(); // ✅ forces all blocks to remount with new keys
            }

            setToast({ show: true, message: "Versio ladattu onnistuneesti!", bg: "success" });
            onClose();

        } 
          catch (error) {
            console.error("Fetch version failed:", error);

            const serverMessage = error.response?.data?.message || JSON.stringify(error.response?.data) || "";
            const status = error.response?.status;

            // alert(
            //   `Version haussa tapahtui virhe.\nStatus: ${status || "unknown"}\nMessage: ${serverMessage || error.message}`
            // );
            setToast({ show: true, message: `Version haussa tapahtui virhe: ${error.message}`, bg: "danger" });

        } finally {
          setLoading(false);
        }
      };



    const nextPage = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const prevPage = () => {
        if (page > 1) setPage(page - 1);
    };

  return (
    <>
      {/* Kortti modal */}
      <Modal show={show} onHide={onClose} size="lg" centered fullscreen="sm-down" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Valitse kappaleen versio</Modal.Title>
          <Modal.Header>Versioita yhteensä: {totalResults}</Modal.Header>
          <Modal.Header>ID: {sectionId}</Modal.Header>
        </Modal.Header>

        <Modal.Body>
          {/* Search */}

          {/* Loading */}
          {loading && (
            <div className="text-center my-4">
              <Spinner animation="border" />
            </div>
          )}



        {/* Results */}
        {!loading && versiot && (
          <div className="row g-3">
            {versiot.map((versio) => (
              <div key={versio.version_id} className="col-md-6">
                <Card className="shadow-sm rounded-3 border-0">
                  <Card.Body>
                    <div className="d-flex flex-column gap-1">

                      {/* Created by */}
                      <div className="text-muted small">Luonut</div>
                      <div className="fw-semibold">
                        {versio?.version_created_by_kayttajatiedot?.nimi}
                      </div>

                      {/* Created at */}
                      <div className="text-muted small mt-1">Päivämäärä</div>
                      <div>{convertToFinnishTime(versio?.version_created_at)}</div>

                      {/* Content size */}
                      <div className="text-muted small mt-1">Sisällön määrä</div>
                      <div className="fw-semibold">
                        {versio?.content_size?.toLocaleString("fi-FI")}
                      </div>

                      {/* Toimenpiteet */}
                      <div className="text-muted small mt-1">
                        Toimenpiteet:{" "}
                        <span className="fw-semibold">{versio.toimenpide_count}</span>{" "}
                        {versio.diff && (
                          <>
                            {versio.diff.toimenpide_delta !== 0 && (
                              <span className={versio.diff.toimenpide_delta > 0 ? "text-success" : "text-danger"}>
                                ({versio.diff.toimenpide_delta > 0 ? "+" : ""}{versio.diff.toimenpide_delta})
                              </span>
                            )}
                            {versio.diff.toimenpide_text_changed && (
                              <span className="text-warning ms-2">(Teksti muuttunut)</span>
                            )}
                          </>
                        )}
                      </div>

                      {/* Images */}
                      <div className="text-muted small mt-1">
                        Piilotetut kuvat:{" "}
                        <span className="fw-semibold">{versio.image_count}</span>{" "}
                        {versio.diff && versio.diff.image_delta !== 0 && (
                          <span className={versio.diff.image_delta > 0 ? "text-success" : "text-danger"}>
                            ({versio.diff.image_delta > 0 ? "+" : ""}{versio.diff.image_delta})
                          </span>
                        )}
                      </div>

                      {/* Text delta */}
                      {versio.diff && versio.diff.text_delta !== 0 && (
                        <div className="text-muted small mt-1">
                          Sisällön muutos:{" "}
                          <span className={versio.diff.text_delta > 0 ? "text-success" : "text-danger"}>
                            {versio.diff.text_delta > 0 ? "+" : ""}{versio.diff.text_delta}
                          </span>
                        </div>
                      )}

                      {/* Changed indicator */}
                      {versio.diff && (
                        <div className="text-muted small mt-1">
                          Muutoksia:{" "}
                          <span className={versio.diff.changed ? "text-success" : "text-danger"}>
                            {versio.diff.changed ? "Kyllä" : "Ei"}
                          </span>
                        </div>
                      )}

                      {/* Select button */}
                      <Button variant="success" size="sm" className="mt-2 w-100" onClick={()=>fetchAndSetFullVersion(versio.version_id)}>
                        Valitse
                      </Button>

                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        )}

          {/* Empty */}
          {!loading && !versiot && (
            <p className="text-center text-muted mt-3">Ei tuloksia.</p>
          )}

          {/* Pagination */}
          {!loading && totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4">
              <Button variant="outline-secondary" disabled={page === 1} onClick={prevPage}>
                ⬅ Edellinen
              </Button>

              <div className="fw-semibold">
                Sivu {page} / {totalPages}
              </div>

              <Button
                variant="outline-secondary"
                disabled={page === totalPages}
                onClick={nextPage}
              >
                Seuraava ➡
              </Button>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Peruuta
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ✅ Confirmation modal */}
      <ConfirmModal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        // onConfirm={handleConfirmChoose}
        title="Vahvista valinta"
        message="Haluatko varmasti valita tämän version?"
        confirmText="Kyllä"
        cancelText="Ei"
        confirmVariant="success"
      />

      <ToastMessage show={toast.show} message={toast.message} bg={toast.bg} onClose={()=>setToast({ show: false, message: "", bg: "success" })}></ToastMessage>
    </>
  );
}

export default SectionVersionsGetter;
